export default __webpack_public_path__ + "static/data-pooling-hero-3949fba413bc286ed811f520cdc8fd6d.mp4";